import map from "./maps.svg";
import button from "./button.svg";
import checkbox from "./checkbox.svg";
import heading from "./heading.svg";
import image from "./image.svg";
import input from "./input.svg";
import link from "./link.svg";
import text from "./text.svg";
import textarea from "./textarea.svg";
import table from "./table.svg";

const components = {
  map,
  button,
  checkbox,
  heading,
  image,
  input,
  link,
  text,
  textarea,
  table,
};

export default components;
